/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerStatisticsListNew = {
    type: 'array',
    contains: {
        type: 'PlayerStatisticsMedium',
    },
} as const;
